$(function() {
	window.slideGallery = new SlideGallery();
});


function SlideGallery() {
	animate = true;
	$container = $('.gallery-slider');
	$items = [];

	function findImages() {
		$.each($items, function() {
			classifyImages($(this).find('.image'));
		});
	}

	function classifyImages(images) {

		$.each(images, function() {
			index = $(this).index();
			if (index == 0) {

				$(this).addClass('large');

			} else if (index == 1) {

				$(this).addClass('medium');

			} else {

				$(this).addClass('small');

			}
		});
	}

	function wrapImages(callback) {
		$container.find('.image').wrapInterval('<div class="item"></div>', 6);
		$items = $container.find('.item');

		callback();
	}

	function setup() {
		if ($container.size() > 0) {

			if( $container.hasClass('is-activated') ){
				findImages();
				return;
			}

			$container.addClass('is-activated');
			wrapImages(function(){
				findImages();
			});
		}

	}

	setup();

	return{
		update: setup()
	}
}

jQuery(window).on('ngPageLoadSuccess', function()
{
	setTimeout( function() {
		window.SlideGallery();
	}, 200 );
});

